export const useLocation = () => {
  if(typeof window !== "undefined") {
    return window.location
  }
  else {
    return {
      host: "localhost:8000",
      hostname: "localhost",
      href: "http://localhost:8000/",
      origin: "http://localhost:8000"
    }
  }
}